import { getConditionalObject } from 'utils/data';

// With the wider desired-target control in the left slot, the filters drop to their own line once
// they can no longer fit two pills per row next to it, instead of stacking one pill per row.
export const getBaseFiltersWrapperStyles = ({ isDesiredTargetEnabled }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 2,
  ...getConditionalObject(isDesiredTargetEnabled, {
    flex: '1 1 360px',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  }),

  '& > button': {
    height: 'auto',
    flexShrink: 0,
  },
});

export const filtersGroupStyles = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 1,
};

export const getProgramsFilterPanelStyles = ({ isDesiredTargetEnabled }) => ({
  flexDirection: 'row',
  flexWrap: isDesiredTargetEnabled ? 'wrap' : 'nowrap',
  gap: 2,
  justifyContent: 'space-between',
  alignItems: 'center',
  px: '17px',
  py: '11px',
  borderTop: 1,
  borderBottom: 1,
  borderColor: ({ palette }) => palette.border.default,
  backgroundColor: ({ palette }) => palette.background.secondary,
});

export const formGroupStyles = {
  gap: 5,
  flexDirection: 'row',
};

export const formControlStyles = {
  display: 'flex',
  gap: 1,

  '& .MuiFormControlLabel-root': {
    height: '20px',

    '&.switch-label': {
      width: 'min-content',
      mx: 0,
    },
  },
};

export const radioStyles = {
  '&.MuiRadio-root:hover': {
    color: ({ palette }) => palette.primary.main,
    backgroundColor: 'transparent !important',
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },

  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
};
